import { InjectionToken } from '@angular/core';
import { Observable, of } from 'rxjs';

export const PROPERTY_SETS_DIALOG_ACTIONS = new InjectionToken<PropertySetsDialogActions<any>>(
  'PROPERTY_SETS_DIALOG_ACTIONS'
);

/**
 * Represents the properties for configuring the actions in the Property Sets Dialog.
 */
export interface PropertySetsDialogActionsProps {
  title: string;
  subtitle?: string;
  hasBackButton?: boolean;
  showActions?: boolean;
  canSave?: boolean;
  saveButtonText?: string;
  cancelButtonText?: string;
  saveTooltipText?: string;
}

/**
 * Represents the actions that can be performed in the Property Sets Dialog.
 */
export interface PropertySetsDialogActions<T> {
  tickDialogProps(state?: T): PropertySetsDialogActionsProps;
  handleSave(state?: T): Observable<boolean>;
  handleCancel(state?: T): void;
  handleBack(state?: T): void;
}

/**
 * Default implementation of the PropertySetsDialogActions.
 */
export class DefaultPropertySetsDialogActions implements PropertySetsDialogActions<unknown> {
  tickDialogProps(): PropertySetsDialogActionsProps {
    return {
      title: 'Missing State Provider',
      subtitle: 'Make sure you provide both PROPERTY_SETS_DIALOG_ACTIONS & PROPERTY_SETS_STATE',
      hasBackButton: false,
      showActions: false,
      saveButtonText: 'Save',
      cancelButtonText: 'Cancel',
      saveTooltipText: null,
    };
  }

  handleSave = () => {
    return of(true);
  };
  handleCancel = (): void => {};
  handleBack = (): void => {};
}
